import { ENDPOINT_DELETE_IMAGE, remove } from './api/services.api';

export const deleteImage = async (path: string) => {
  path = path.replace(process.env.GB_SERVICES_PDF_TO_IMAGES+ '/', '');
  await remove(ENDPOINT_DELETE_IMAGE, { path });
};
